export default __webpack_public_path__ + "static/media/globe.40de0ba7.svg";